<template>
  <q-card flat style="width: 600px; max-width: 80vw;">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <q-badge align="top" class="bg-red q-ml-xs" :label="product.Goods_Code"/>
        {{ product.title }}
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <span class="text-subtitle1">عنوان برون سازمانی </span>
      <span class="text-subtitle2">({{product.Goods_NameA}})</span>
    </q-card-section>
    <q-card-section class="q-gutter-sm no-padding q-ml-xs text-center">
      <q-badge align="top" color="deep-orange" text-color="white"><i>موجودی(</i><b>{{ product.Goods_Stock }}</b><i>)
        {{ product.Unit_Name }}</i></q-badge>
      <q-badge align="top" color="deep-orange " text-color="white"><i>واحد شمارش(</i><b>{{ product.Unit_Name }}</b>)
      </q-badge>
      <q-badge align="top" color="deep-orange" text-color="white"><i>نقطه جوش(</i><b>{{ product.Goods_Min }}</b>)
      </q-badge>
    </q-card-section>
    <q-card-section class="text-center">
      <ProductActions :is-selection-form="false" :goods-info="product" @goodsPriceUpdated="goodsPriceUpdated" />
    </q-card-section>
    <q-card-section class="row items-center no-padding text-center">
      <q-img :src="imageData"
             :ratio="4/3"
             width="100%"
             height="100%"
             contain
             :alt="product.title"
             v-if="imageData"
             placeholder-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWBAMAAADOL2zRAAAAG1BMVEXMzMyWlpaqqqq3t7fFxcW+vr6xsbGjo6OcnJyLKnDGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABAElEQVRoge3SMW+DMBiE4YsxJqMJtHOTITPeOsLQnaodGImEUMZEkZhRUqn92f0MaTubtfeMh/QGHANEREREREREREREtIJJ0xbH299kp8l8FaGtLdTQ19HjofxZlJ0m1+eBKZcikd9PWtXC5DoDotRO04B9YOvFIXmXLy2jEbiqE6Df7DTleA5socLqvEFVxtJyrpZFWz/pHM2CVte0lS8g2eDe6prOyqPglhzROL+Xye4tmT4WvRcQ2/m81p+/rdguOi8Hc5L/8Qk4vhZzy08DduGt9eVQyP2qoTM1zi0/uf4hvBWf5c77e69Gf798y08L7j0RERERERERERH9P99ZpSVRivB/rgAAAABJRU5ErkJggg=="
      />
    </q-card-section>
    <q-card-section class="text-center no-padding">
      <q-btn icon="delete" color="red" round dense @click="DeletePicture"
             v-if="product.EXISTSImage===1 && $store.state.roles.some(v=>['admin', 'edit_product_picture'].includes(v))"/>
      <q-btn v-if="imageData!==''" icon="download" color="indigo" class="q-ma-xs" round dense
             @click="downloadPicture(product.title,imageData)"/>
    </q-card-section>
    <q-card-section
        v-if="product.EXISTSImage===0 && $store.state.roles.some(v=>['admin', 'edit_product_picture'].includes(v))"
        class="row justify-center items-center no-padding q-mt-xs">
      <div class="row justify-center items-center">
        <div class="col">
          <q-uploader
              label="انتخاب فایل تصویر محصول"
              :factory="factoryFn"
              method="POST"
              style="max-width: 300px"
              ref="uploader"
              :multiple="false"
              @rejected="onRejectUpload"
              @uploaded="onUploaded"
              @finish="onUploadFinished"
          />
        </div>
      </div>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip :size="$q.screen.lt.md?'md':'md'" color="indigo" text-color="white">{{ product.Group_Name }}</q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip label="وزن" square icon="scale">
        <q-badge align="middle" floating color="red" text-color="white" :label="product.Goods_weight"/>
      </q-chip>
      <q-chip label="حجم" square icon="straighten">
        <q-badge align="middle" floating color="red" text-color="white" :label="product.Goods_Volume"/>
      </q-chip>

    </q-card-section>
    <q-card-section class="no-padding" v-if="product.Goods_SaleTax_D && product.Goods_SaleTax_D>0">
      <q-chip square color="red" text-color="white" size="sm"
              :label="`شامل ${product.Goods_SaleTax_D} درصد ارزش افزوده می باشد `"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <div
          v-if="$store.state.roles.some(v=>['admin', 'can_see_product_price'].includes(v))"
          class="text-weight-bolder text-subtitle2 q-ml-xs q-ml-md">
        قیمت فروش (ریال)
      </div>
    </q-card-section>
    <q-separator/>
    <q-card-section
        v-if="$store.state.roles.some(v=>['admin', 'can_see_product_price'].includes(v))"
        class="q-pa-none">
      <div class="row">
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="نقد کارتن">
            <q-badge color="deep-orange-10" class="q-ml-xs">{{ product.SaleG_Price_Box | toLoalString }}</q-badge>
          </q-chip>
        </div>
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="نقد بسته">
            <q-badge color="deep-orange-10" class="q-ml-xs">{{ product.SaleG_Price | toLoalString }}</q-badge>
          </q-chip>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="لیست">
            <q-badge color="blue" class="q-ml-xs">{{ product.List_Price | toLoalString }}</q-badge>
          </q-chip>
        </div>
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="اتحادیه">
            <q-badge color="pink" class="q-ml-xs">
              {{ product.Price | toLoalString }}
            </q-badge>
          </q-chip>
        </div>
      </div>
    </q-card-section>
    <q-separator/>
    <div class="text-weight-bolder text-subtitle2 q-ml-xs q-ml-md"
         v-if="$store.state.roles.some(v=>['admin', 'can_see_by_price','can_see_buy_day_price'].includes(v))">
      قیمت خرید (ریال)
      <q-badge color="red" class="q-ml-xs" v-if="product.BuyDay_Date">تاریخ خرید روز (<b>{{ product.BuyDay_Date }}</b>)
      </q-badge>
      <q-badge color="red" class="q-ml-xs" v-if="product.BuyLast_Date">تاریخ آخرین خرید (<b>{{
          product.BuyLast_Date
        }}</b>)
      </q-badge>
    </div>
    <q-card-section v-if="$store.state.roles.some(v=>['admin', 'can_see_by_price'].includes(v))" class="q-pa-none">
      <div class="row">
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="آخرین خرید">
            <q-badge color="deep-orange" class="q-ml-xs">{{
                parseInt(product.BuyLast_Price).toLocaleString()
              }}
            </q-badge>
          </q-chip>
        </div>
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="روز">
            <q-badge color="secondary" class="q-ml-xs">{{ parseInt(product.BuyDay_Price) | toLoalString }}</q-badge>
          </q-chip>
        </div>
      </div>
    </q-card-section>
    <q-card-section class="q-pa-none">
      <q-separator/>
      <div class="row">
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat
                  :label="(product.List_Price===0 || product.List_Price==='' || product.List_Price==null)?'سود کم':'تخفیف کم'">
            <q-badge color="purple" class="q-ml-xs">{{
                (product.List_Price === 0 || product.List_Price === '' || product.List_Price == null) && !$store.state.roles.some(v => ['admin', 'see_profit'].includes(v)) ? 0 : product.Per_Min
              }}
            </q-badge>
          </q-chip>
        </div>
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat
                  :label="(product.List_Price===0 || product.List_Price==='' || product.List_Price==null) ?'سود زیاد':'تخفیف زیاد'">
            <q-badge color="indigo-14" class="q-ml-xs">{{
                (product.List_Price === 0 || product.List_Price === '' || product.List_Price == null) && !$store.state.roles.some(v => ['admin', 'see_profit'].includes(v)) ? 0 : product.Per_Max
              }}
            </q-badge>
          </q-chip>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="تعداد در کارتن">
            <q-badge color="indigo-14" class="q-ml-xs">{{ product.Goods_Box }}</q-badge>
          </q-chip>
        </div>
        <div class="col">
          <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="تعداد در بسته">
            <q-badge color="purple" class="q-ml-xs">{{ product.Goods_Pak }}</q-badge>
          </q-chip>
        </div>
      </div>
    </q-card-section>
    <q-separator/>
    <div class="text-weight-bolder text-subtitle2 q-ml-xs q-ml-md">
      موجودی به تفکیک انبار
    </div>
    <q-card-section class="q-pa-none">
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="مرکزی">
        <q-badge color="deep-orange-10" class="q-ml-xs">{{ product.GStor1 }}</q-badge>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="پل پنجم">
        <q-badge color="blue" class="q-ml-xs">{{ product.GStor3 }}</q-badge>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="فروشگاه">
        <q-badge color="deep-orange-10" class="q-ml-xs">{{ product.GStor2 }}</q-badge>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="کارخانه صاف">
        <q-badge color="pink" class="q-ml-xs">
          {{ product.GStor4 }}
        </q-badge>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="دیجیکالا" v-if="product.GStor6">
        <q-badge color="blue" class="q-ml-xs">{{ product.GStor6 }}</q-badge>
      </q-chip>
      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="انبار ضایعات" v-if="product.GStor5">
        <q-badge color="blue" class="q-ml-xs">{{ product.GStor5 }}</q-badge>
      </q-chip>
    </q-card-section>
    <q-card-section v-if="product.Descriptions">
      <span style="white-space: pre-wrap;">{{product.Descriptions}}</span>
    </q-card-section>
    <q-dialog maximized v-model="showCartex">
      <GoodsCartex :goods-info="product"/>
    </q-dialog>
  </q-card>
</template>

<script>
import axios from "axios";
import {mapActions} from "vuex";
import {Capacitor} from "@capacitor/core";
import {Directory, Filesystem, Encoding} from '@capacitor/filesystem';
import GoodsCartex from "@/components/store/GoodsCartex";
import ProductActions from "@/components/productInfo/ProductActions.vue";

export default {
  name: "ProductDetail",
  components: {ProductActions, GoodsCartex},
  props: ['product'],
  data() {
    return {
      showCartex: false,
      imageData: '',
      imageID: ''
    }
  },
  computed: {
    file_upload_url_cb() {
      if ('ID' in this.product) {
        return `${axios.defaults.baseURL}/upload_product_image/${this.product.ID}`
      } else {
        return undefined
      }
    }
  },
  methods: {
    ...mapActions({
      getImagePic: 'Products/getImagePic',
      deleteImagePicture: 'Products/deleteProductImage',
    }),
    goodsPriceUpdated(args){
      this.$emit('goodsPriceUpdated', args)
    },
    showCatexDialog() {
      this.showCartex = true;
    },
    factoryFn() {
      return {
        url: this.file_upload_url_cb,
        method: 'POST',
        headers: [
          {
            name: 'Authorization', value: `Bearer ${this.$store.state.accessToken}`
          }
        ]
      }
    },
    async downloadPicture(name, imageData) {
      if (Capacitor.getPlatform() === 'web') {
        let FileSaver = require('file-saver');
        FileSaver.saveAs(imageData, `${name}.jpg`);
      } else {
        const fileName = `${name}.jpg`;
        await Filesystem.writeFile({
          path: fileName.trim(),
          data: imageData,
          directory: Directory.Documents,
          encoding: Encoding.UTF
        }).then(() => {
          this.$q.notify({
            message: 'فایل در شاخه Documents دانلود گردید',
            color: 'positive',
            type: 'positive',
            position: 'top'
          });
        })
      }
    },
    // eslint-disable-next-line no-unused-vars
    onUploaded({info, xhr}) {
      let responseImage = JSON.parse(xhr.response)[0];
      this.imageData = `data:image/${responseImage.Goods_Image_Content_Extensions.replace(".", "")};base64,${responseImage.Goods_Image_Content}`;
      this.product.EXISTSImage = 1;
      this.imageID = responseImage.Goods_ID;
      this.$q.notify({
        message: 'بارگذاری تصویر محصول به پایان رسید',
        color: 'positive',
        type: 'positive',
        position: 'top'
      });
    },
    onUploadFinished() {
      this.$refs.uploader.reset()
    },
    onRejectUpload(rejectedEntries) {
      this.$q.notify({
        type: 'negative',
        position: 'top',
        message: `${rejectedEntries.length} file(s) did not pass validation constraints`
      })
    },
    DeletePicture() {
      this.deleteImagePicture(this.imageID).then(() => {
        this.imageID = '';
        this.imageData = '';
        this.product.EXISTSImage = 0;
      });
    }
  },
  created() {
    this.getImagePic(this.product.ID).then((res) => {
      if (res.length > 0) {
        this.imageID = res[0].Goods_ID;
        this.imageData = `data:image/${res[0].Goods_Image_Content_Extensions.replace(".", "")};base64,${res[0].Goods_Image_Content}`;
      }
    });
  }
}
</script>

<style scoped>

</style>
